<!-- Responsibility: Display a blocking notice when AI settings are missing.
Scope: Alert dialog for AI configuration requirements. -->
<preforge-blocking-notice>
  <section class="preforge-blocking-popup" role="alertdialog" aria-modal="true" aria-live="assertive">
    <div class="preforge-blocking-card">
      <p class="preforge-blocking-eyebrow">AI SETTINGS REQUIRED</p>
      <h2>{ props.notice.title }</h2>
      <p class="panel-copy">{ props.notice.copy }</p>
      <ul if={ props.notice.details && props.notice.details.length } class="preforge-blocking-details">
        <li each={ detail in props.notice.details }>{ detail }</li>
      </ul>
      <div class="preforge-blocking-actions">
        <button type="button" class="btn btn-primary" onclick={ props.onAction }>{ props.notice.actionLabel }</button>
        <button type="button" class="btn btn-ghost" onclick={ props.onDismiss }>DISMISS</button>
      </div>
    </div>
  </section>

  <style>
    .preforge-blocking-popup {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: var(--z-admin-overlay, 1300);
      backdrop-filter: blur(4px);
    }
    .preforge-blocking-card {
      max-width: 31.25rem;
      padding: var(--space-xl);
      background: var(--surface-raised);
      border: 1px solid var(--border);
      border-radius: 1rem;
      text-align: center;
      display: grid;
      gap: var(--space-md);
    }
    .preforge-blocking-eyebrow { font-size: 0.7rem; color: var(--gold); letter-spacing: 0.1em; margin: 0; }
    .preforge-blocking-details { list-style: none; padding: 0; margin: 0; text-align: left; font-size: 0.8rem; color: var(--text-muted); }
    .preforge-blocking-actions { display: flex; gap: var(--space-sm); justify-content: center; }
  </style>
</preforge-blocking-notice>
